module.exports = __webpack_public_path__ + "static/scientist14-d37159a3362f451c6b8b9bee20ecb246.jpg";